import React from 'react';
import $ from 'jquery';
import ResourceService from '../../services/resource.service';
import CommonMessage from '../common/commonMessage';
import { isNumber, maskEmail } from '../../utility/utility';
import { userService } from '../../services/user.service';
// import PhoneInput from 'react-phone-input-2'
// import 'react-phone-input-2/lib/style.css'
import QRCode from "qrcode.react";
import { axiosRequestWithAuth, API_HOST, axiosInstance } from '../../constants/server.constant';
import Axios from 'axios';
import Validate from '../common/validate';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import SessionService from '../../services/session.service';
import ReCAPTCHA from "react-google-recaptcha";
import { loginService } from '../../services/login.service';
class SubUsertwoFaLoginConfigure extends React.Component {


    constructor(props) {
        super(props);
        var countryCde = localStorage.getItem('countryCode');
        //$('head').append('<link rel="stylesheet" href = "https://www.idrivecompute.com/webapp/css/2fa-style.css">');
        this.state = {
            isEmail: true,
            isPhone: false,
            isTotp: false,
            isEmailConfirm: false,
            isPhoneConfirm: false,
            isTotpConfirm: false,
            phone: localStorage.getItem('phone'),
            isPhoneReg: false,
            email: localStorage.getItem('email'),
            countryCode: countryCde !== null && countryCde !== '' ? countryCde : 'USA +1',
            message: '',
            message_v2: '',
            msgType: '',
            msgType: '',
            isOtpSent: false,
            qrValue: '',
            recoveryCode: '',
            secretKey: '',
            userId: localStorage.getItem("userId"),
            roleId: localStorage.getItem("roleId"),
            totpCode: '',
            isAction: false,
            isQrcodeShow: true,
            isCodeExpired: false
        };
        this.recaptchaRef = React.createRef();
    }

    componentWillUnmount() {
        clearInterval(this.timerId);
        clearInterval(sessionStorage.timerId);
    }

    inputChangeHandler = (event) => {
        this.setState({
            totpErrorMssg: ""
        });
        let name = event.target.name;
        let val = event.target.type === 'radio' ? event.target.checked : event.target.value;
        if(name === 'isEmail') {
            this.setState({ [name]: val, isPhone: false, isTotp: false });
        } else if(name === 'isPhone') {
            this.setState({ [name]: val, isEmail: false, isTotp: false });
        } else if(name === 'isTotp') {
            this.setState({ [name]: val, isEmail: false, isPhone: false, isQrcodeShow: true });
        } else {
            // if (name === 'otp') {
            //     if( val !== '' && !isNumber(val)){
            //         return;
            //     }
            // }
            if(name === 'phone') {
                this.checkPhoneRegex();
            }
            this.setState({ [name]: val, phoneNumberEmpty: false, countrycodeempty: false });
        }
    };

    getTotpDetails() {
        //if(this.state.secretKey!==undefined && this.state.secretKey!=='') return
        this.setState({ isAction: true });
        axiosInstance.get(API_HOST + "/2fa/totp/" + this.state.userId, axiosRequestWithAuth)
            .then(resp => {
                let info = resp.data.body;
                if(info.error === "true") {
                    this.setState({
                        isAction: false,
                        message: "Error while doing operation totp",
                        msgType: "error"
                    });
                }
                else {
                    let url = "otpauth://totp/IDriveCompute%3A" + this.state.email + "?secret=" + info.secretKey + "&issuer=IDriveCompute";
                    this.setState({
                        totpCode: '',
                        isAction: false,
                        secretKey: info.secretKey,
                        recoveryCode: info.recoveryKey,
                        qrValue: url
                    });
                }

            }).catch(err => {
                this.setState({
                    isAction: false,
                    message: "Error while doing operation totp",
                    msgType: "error"
                });
            });
    }


    verifyTotp = (event) => {
        if(this.state.totpCode.trim().length <= 0) {
            this.setState({ totpErrorMssg: "TOTP code cannot be blank" });
        } else if(!Validate("otp", this.state.totpCode.trim())) {
            this.setState({ totpErrorMssg: "Invalid TOTP" });
        } else {
            axiosInstance.post("/2fa/totp/verify/sub-configure/" + this.state.userId + "?code=" + this.state.totpCode, null, axiosRequestWithAuth).then(resp => {
                this.redirectAfterVerification(resp);
            }).catch(error => {
                if(error?.response?.status === 417) {
                    this.setState({
                        isAction: false,
                        totpErrorMssg: "Enter a valid verification code",
                        isTotpMsg: false,
                        viewTotpMessage: ''
                    });
                } else if(error?.response?.status === 403) {
                    this.setState({
                        isAction: false,
                        message_v2: 'Forbidden Access. Verfication terminated.',
                        msgType_v2: 'error',
                        isTotpMsg: false,
                        viewTotpMessage: '',
                    });
                } else {
                    this.setState({
                        isAction: false,
                        message_v2: 'Unable to verify TOTP. Please try again later.',
                        msgType_v2: 'error',
                        isTotpMsg: false,
                        viewTotpMessage: ""
                    });
                }
            });
        }
    };

    submit = () => {
        if(this.state.isEmail) {
            this.setState({ isEmailConfirm: true, isPhoneConfirm: false, isTotpConfirm: false, otp: '' });
            this.sendOtp(1);
            setTimeout(() => $('#emailotp').focus(), 100);
        } else if(this.state.isPhone) {
            let phoneNo = localStorage.getItem('phone');
            if(phoneNo !== null && phoneNo) {
                this.setState({ isPhoneConfirm: true, isEmailConfirm: false, isTotpConfirm: false, isPhoneReg: true, otp: '' }, () => $('#otp').focus());
                this.sendOtp(2);
            } else {
                this.setState({ isPhoneConfirm: true, isEmailConfirm: false, isTotpConfirm: false, otp: '', phone: '' });
            }
            setTimeout(() => $('#smsotp').focus(), 100);
        } else if(this.state.isTotp) {
            this.getTotpDetails();

            $(".idcmp-totp-pop").addClass("active");
            $(".idcmp-2fa-copycode").removeClass("active");
            $(".idcmp-2fa-totp").removeClass("idcmp-hide");
            $(".idcmp-2fa-verifycode").removeClass("active");
            $("body").addClass("noscroll");
            this.setState({ isTotpConfirm: true, isEmailConfirm: false, isPhoneConfirm: false, isQrcodeShow: true, isCodeCopied: false, totpErrorMssg: '' });

        }
    };


    showRecoveryCode() {

    }

    back = () => {
        this.setState({ isTotpConfirm: false, isEmailConfirm: false, isPhoneConfirm: false, isOtpSent: false });
        if(sessionStorage.type === 'send') {
            this.setState({ isPhoneReg: false });
        }
        clearInterval(sessionStorage.timerId);

    };


    sendOtp = (type) => {
        var cLabel = this.state.countryCode;
        var c = cLabel.split('+');
        var cCode = '+' + c[1];
        var otpDetails = {
            "email": this.state.email,
            "countryCode": cCode.trim(),
            "phone": this.state.phone
        };

        if(type == 1) {
            this.setState({
                otpDetails: otpDetails,
                captchaType: "email"
            }, () => this.recaptchaRef.current.execute());
        } else if(type == 2) {
            this.setState({
                otpDetails: otpDetails,
                captchaType: "sms"
            }, () => this.recaptchaRef.current.execute());
        }

    };
    onRecaptchaChange = (event) => {
        if(this.state.captchaType == "email") {
            this.sendEmailOtp(this.state.otpDetails, event);
        }
        else {
            this.sendPhoneOtp(this.state.otpDetails, event);
        }

    };

    sendEmailOtp(otpDetails, event) {
        ResourceService.sendEmailOtp(otpDetails, event).then(res => {
            if(res === undefined) {
                this.setState({
                    message: "Email could not be verified.",
                    msgType: 'error'
                });
                if(this.recaptchaRef.current)
                    this.recaptchaRef.current.reset();
                //this.phoneNUmberFocus.current.focus()
            } else {
                this.setState({ isOtpSent: true, message: 'Verification code has been sent', isCodeExpired: false, msgType: 'success' });
                clearInterval(this.timerId);
                this.startTimer();
                //$('#verify_otp_msg').hide();
                $('#otp').removeAttr('disabled');
                $('#resend_msg').show();
                // setTimeout(() => {
                //     $('#resend_msg').hide();
                // }, 3000);
                //this.otpInput.current.focus()
            }
        });
    }

    sendPhoneOtp(otpDetails, event) {
        ResourceService.sendOtp(otpDetails, event).then(res => {
            if(res === undefined) {
                this.setState({
                    message: "Phone number could not be verified. Enter a valid phone number and try again.",
                    msgType: 'error'
                });
                if(this.recaptchaRef.current)
                    this.recaptchaRef.current.reset();
                $('#phone').focus();
            } else {
                this.setState({ isOtpSent: true, message: 'Verification code has been sent', isCodeExpired: false, msgType: 'success' });
                clearInterval(this.timerId);
                this.startTimer();
                if(sessionStorage.type === 'send') {
                    this.setState({ isPhoneReg: true });
                }

                //$('#verify_otp_msg').hide();
                // $('#otp').removeAttr('disabled');
                //$('#resend_msg').show();
                // setTimeout(() => {
                //     $('#resend_msg').hide();
                // }, 3000);
                //this.otpInput.current.focus()
            }
        });
    }

    startTimer() {
        //var mindisp = 0;
        //var secdis = 0;
        $("#otp_timer").html("Your verification code will expire in <b> 05:00 </b> Minutes");
        var countdown = 5 * 60 * 1000;
        //var timerId ;
        //clearInterval(timerId);
        sessionStorage.timerId = this.timerId = setInterval(() => {
            countdown -= 1000;
            var min = Math.floor(countdown / (60 * 1000));
            //var sec = Math.floor(countdown - (min * 60 * 1000));  // wrong
            var sec = Math.floor((countdown - (min * 60 * 1000)) / 1000);
            if(min == 0 && sec == 0) {
                clearInterval(this.timerId);
                $('#otp_timer').html('The verification code has expired. Click "Resend OTP" to receive new code.');
                this.setState({
                    otp: "",
                    isOtpSent: false

                }, () => {
                    $('#otp').attr("disabled", "disabled");
                    this.setState({ isCodeExpired: true });
                });
            } else {
                this.mindisp = min;
                this.secdis = sec;
                if(min < 10)
                    this.mindisp = "0" + min;
                if(sec < 10)
                    this.secdis = "0" + sec;
                if(min == 0) {
                    $("#otp_timer").html("Your verification code will expire in <b>" + this.mindisp + ":" + this.secdis + "</b> Seconds");
                } else {
                    $("#otp_timer").html("Your verification code will expire in <b>" + this.mindisp + ":" + this.secdis + "</b> Minutes");
                }
            }

        }, 1000);
    }

    redirectAfterVerification = (authResp) => {
        let state = { fromSub2faConfigure: true };
        if(authResp?.data?.emailTransfer)
            state.emailTransfer = authResp.data.emailTransfer;
        userService.getUser().then(response => {
            loginService.setUserLocal(response, true);
        }).catch(error => {
            console.error("Error while fetching user details after sub-user two-fa configuration ...");
            loginService.redirectToLogin();
        });
        if(SessionService.getCookie("_redirect_url"))
            this.props.history.push({ pathname: SessionService.getCookie("_redirect_url"), state: state });
        else
            this.props.history.push({ pathname: '/index', state: state });
    };

    verifyOtp() {

        if(this.state.otp === undefined || this.state.otp.trim() === '') {
            this.setState({ message: 'Verification code cannot be blank', msgType: 'error' });
            $('#otp').focus();
            return;
        }

        var otpDetails = {
            "email": this.state.email,
            "otp": this.state.otp.trim()
        };

        var type = this.state.isEmailConfirm ? 1 : 2;
        ResourceService.verifySubAccOtp(otpDetails, type).then(authResp => {
            if(sessionStorage.type === "send") {
                userService.updatePhoneDetails(this.state.countryCode, this.state.phone).then(resp => {
                    if(resp !== undefined && resp === '') {
                        sessionStorage.type = "";
                        this.redirectAfterVerification(authResp);
                    }
                });
            } else {
                this.redirectAfterVerification(authResp);
            }
        }).catch(error => {
            if(this.recaptchaRef.current)
                this.recaptchaRef.current.reset();
            $('#otp').focus();
            if(error?.response?.data) {
                let data = error.response.data;
                if(data?.error) {
                    switch(data.error) {
                        case "invalid_credentials":
                            this.setState({
                                message: 'Incorrect verification code. Please try again.',
                                msgType: 'error'
                            });
                            return;
                        case "exceeded_retries":
                            this.setState({
                                message: 'Exceeded query limit. Please try again after some time.',
                                msgType: 'error'
                            });
                            return;
                        default:
                            break;
                    }
                }
            }
            this.setState({
                message: 'Error while verifying OTP.',
                msgType: 'error'
            });
        });
    }

    onSupportedAppClick = () => {
        $(".totpSupport_popup").addClass("active");
        $("body").addClass("noscroll");
    };

    onSupportedAppCloseClick = () => {
        $(".totpSupport_popup").removeClass("active");
        $("body").removeClass("noscroll");

    };

    onTotpCloseClick = () => {
        $(".idcmp-totp-pop").removeClass("active");
        $("body").removeClass("noscroll");

    };

    onNextTotpClick = () => {
        $(".idcmp-2fa-copycode").addClass("active");
        $(".idcmp-2fa-totp").addClass("idcmp-hide");

    };

    onBackTotpClick = () => {
        $(".idcmp-2fa-copycode").removeClass("active");
        $(".idcmp-2fa-totp").removeClass("idcmp-hide");
    };

    onContinueTotpClick = () => {
        if(this.state.isCodeCopied) {
            $(".idcmp-2fa-copycode").removeClass("active");
            $(".idcmp-2fa-verifycode").addClass("active");
            $('#totpcode').focus();
        }
    };

    downloadTotpCodeFlile(text) {
        const element = document.createElement("a");
        const file = new Blob([text],
            { type: 'text/plain;charset=utf-8' });
        element.href = URL.createObjectURL(file);
        element.download = "IDriveCompute_Recovery_Code.txt";
        document.body.appendChild(element);
        element.click();
        this.setState({ isCodeCopied: true });
    }

    copyCodeClick(event) {
        // this.setState({
        //     isCopied:true
        // })
        var recoveryCode = this.state.recoveryCode;
        var textField = document.createElement('textarea');
        textField.innerText = recoveryCode;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
        $(".idcmp-2fa-copycode .idcmp-2fa-copylink b").css("background", "rgb(255, 255, 0)");
        $(".idcmp-2fa-copycode .idcmp-2fa-copylink b").text("Code Copied");
        setTimeout(function () {
            $(".idcmp-2fa-copycode .idcmp-2fa-copylink b").css("background", "rgb(255, 255, 255)");
            $(".idcmp-2fa-copycode .idcmp-2fa-copylink b").text(recoveryCode);
        }, 800);
        this.setState({ isCodeCopied: true });
    }

    componentDidMount() {
        $(document).keyup(function (e) {
            if(e.keyCode === 27) {
                $(".idcmp-totp-pop").removeClass("active");
                $(".totpSupport_popup").removeClass("active");   // esc
                $("body").removeClass("noscroll");   // esc
            }
        });
        $('#emailcheckmark').focus();
        this.checkPageInfo();
    }

    checkPageInfo() {
        ResourceService.getPageInfo().then(resp => {
            if(resp && resp !== '') {
                if(!resp.includes(window.location.href)) {
                    this.topBackbttnClick();
                }
            }
        });
    }


    onKeyUPDown(event) {
        if(event.keyCode === 38) {
            if(this.state.isEmail === true) {
                return;
            } else if(this.state.isPhone === true) {
                this.setState({ isEmail: true, isPhone: false });
            } else if(this.state.isTotp === true) {
                this.setState({ isTotp: false, isPhone: true });
            }
        } else if(event.keyCode === 40) {
            if(this.state.isEmail === true) {
                this.setState({ isEmail: false, isPhone: true });
            } else if(this.state.isPhone === true) {
                this.setState({ isTotp: true, isPhone: false });
            } else if(this.state.isTotp === true) {
                return;
            }
        }
    }

    resendOtp() {
        this.setState({ isResendClicked: true });
        if(this.state.isEmailConfirm) {
            this.sendOtp(1);
        } else if(this.state.isPhoneConfirm) {
            this.sendOtp(2);
        }
        $('#otp').focus();
        var timeout = setTimeout(() => {
            this.setState({ isResendClicked: false });
            clearTimeout(timeout);
        }, 10000);
    }

    sendPhoneCode() {
        if(this.state.countryCode === null || this.state.countryCode === undefined || this.state.countryCode === '') {
            this.setState({ countrycodeempty: true });
            return;
        }
        if(this.state.phone === undefined || this.state.phone.trim() === '') {
            this.setState({ phoneNumberEmpty: true });
            $('#phone').focus();
            return;
        }
        sessionStorage.type = 'send';
        this.sendOtp(2);
    }


    viewRecoveryCode = () => {
        this.setState({
            totpCode: "",
            totpError: false,
            totpEmpty: false,
            isViewMsg: false,
            viewCodeMessage: "",
            isCopied: false
        });
        if(this.state.totpCode.trim().length <= 0) {
            this.setState({
                totpError: false,
                totpEmpty: true
            });
        }
        else if(!Validate("otp", this.state.totpCode.trim())) {
            this.setState({
                totpError: false,
                totpEmpty: true
            });
        }
        else {
            this.setState({
                isViewMsg: true,
                viewCodeMessage: "OTP is validating..."
            });
            axiosInstance.get(API_HOST + "/2fa/totp/recoveryCode/" + this.state.userId + "?code=" + this.state.totpCode, axiosRequestWithAuth)
                .then(resp => {
                    if(resp.data.body != "") {
                        this.setState({
                            isCodeStp1: false,
                            isCodeStp2: true,
                            recoveryCode: resp.data.body
                        });
                    }
                    else {
                        this.setState({
                            isAction: false,
                            totpError: true
                        });
                    }

                })
                .catch(error => {
                    this.setState({
                        isAction: false,
                        totpEmpty: true
                    });
                });
        }
    };


    topBackbttnClick() {
        loginService.redirectToLogin();
        //this.props.history.push('/login')
    }

    on2faKeydown(e, name) {
        if(e.keyCode === 13) {
            if(name === 'verifyOtp') {
                this.verifyOtp();
            }
            if(name === 'verifyTotp') {
                this.verifyTotp();
            }
        }

    }


    checkPhoneRegex = () => {
        let val = this.state.phone;
        if(val.length > 0) {
            this.setState({
                phoneEmpty: false,
                phoneError: false
            });

            if(val.length >= 7) {
                $('#min_sev').addClass("success");
            } else {
                $('#min_sev').removeClass("success");
            }

            if(val.length > 0 && val.length <= 20) {
                $('#max_twe').addClass("success");
            } else {
                $('#max_twe').removeClass("success");
            }

            const phoneNumRegex = new RegExp("^[xX0-9-+()]+$");
            if(phoneNumRegex.test(val)) {
                $('#no_spe').addClass("success");
            } else {
                $('#no_spe').removeClass("success");
            }
        }
        else {
            this.setState({
                phoneEmpty: true
            });
            $('#min_sev').removeClass("success");
            $('#max_twe').removeClass("success");
            $('#no_spe').removeClass("success");

        }
    };

    redirectToIndex() {
        window.location = "https://www.idrivecompute.com/index.html";
    }

    render() {
        var emailHalf = maskEmail(this.state.email);
        var phone = this.state.phone;
        var phoneNoMask = '';
        if(phone) {
            phoneNoMask = phone.slice(0, 2) + phone.slice(2).replace(/.(?=...)/g, '*');
        }
        return (
            <body className="idcmp-frontend-main">
                <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                    <div className="loader_icon"></div>
                </div>
                <header>
                    <div className="idcmp-container">
                        <a href="#" className="back_btn" onClick={ (e) => { this.topBackbttnClick(); e.preventDefault(); } } data-tip data-for="back" >
                            <span >
                                <svg x="0px" y="0px" width="50px" height="30px" viewBox="0 0 50 30" enableBackground="new 0 0 50 30" xmlSpace="preserve">
                                    <g>
                                        <path fill="#F3F3F3" d="M49,3.01v23.98C49,28.1,48.1,29,47,29H3c-1.1,0-2-0.9-2-2.01V3.01C1,1.9,1.9,1,3,1h44
                                C48.1,1,49,1.9,49,3.01z"></path>
                                        <path fill="#CCCCCB" d="M47,0H3C1.34,0,0,1.35,0,3.01v23.98C0,28.65,1.34,30,3,30h44c1.66,0,3-1.35,3-3.01V3.01
                                C50,1.35,48.66,0,47,0z M49,26.99C49,28.1,48.1,29,47,29H3c-1.1,0-2-0.9-2-2.01V3.01C1,1.9,1.9,1,3,1h44c1.1,0,2,0.9,2,2.01V26.99z
                                "></path>
                                    </g>
                                    <polygon fill="#636363" points="33,10 33,15.99 23,16 23,21 17,15 23,9 23,14 31,14 31,10 "></polygon>
                                </svg>
                            </span>
                        </a><ReactTooltip id="back" place="right" effect="solid">Back to login</ReactTooltip>
                        <div className="idcmp-logo" onClick={ () => this.redirectToIndex() }>
                            <a href="#" onClick={ (e) => e.preventDefault() }><img src="https://www.idrivecompute.com/webapp/images/computelogo_blue.svg" alt="IDrive Compute Logo" /></a>
                        </div>
                    </div>
                </header>
                <div className="idcmp-2fa-wrpr idcmp-2fa-atcn">

                    <div className="idcmp-2fa-blk idcmp-admin-2fa-blk">
                        <h1 className="idcmp-2fa-title">Admin has enabled two-factor authentication for your account</h1>
                        <p className="idcmp-2fa-content">You can choose one of the following methods to receive the one-time verification code. If you choose Time-based OTP authentication, follow the on-screen steps to complete the verification process. In case you choose email or phone number, enter the received code to complete the verification.</p>
                        <p className="idcmp-2fa-content">Once verified and two-factor authentication enabled, you will need to enter your password and the verification code, during subsequent logins. <a href="https://www.idrivecompute.com/faq.htm#two-step-1" className="idcmp-more-link" target="_blank">Know more</a></p>
                        <div className="idcmp-2fa-code-blk">
                            <div className={ this.state.isEmailConfirm || this.state.isPhoneConfirm ? "idcmp-verfy-blk idcmp-verify-optns-blk idcmp-hide" : "idcmp-verfy-blk idcmp-verify-optns-blk" }>
                                <h2>Choose verification method:</h2>
                                <div className="idcmp-verfy-blk-radio">
                                    <div className="idcmp-radio-container">
                                        <label className="idcmp-radio-check"><span className="checkCaption"><i>Email Address</i><i>(</i><b>{ emailHalf }</b><i>)</i></span>
                                            <input type="radio" id="emailcheckmark" className="idcmp-form-ctrl" name="isEmail" value="email" checked={ this.state.isEmail } onChange={ (e) => this.inputChangeHandler(e) } onKeyDown={ (e) => this.onKeyUPDown(e) } />
                                            <span className="idcmp-radio-checkmark"></span>
                                        </label>
                                    </div>
                                    <div className="idcmp-radio-container">
                                        <label className="idcmp-radio-check">Phone Number
                                            <input type="radio" className="idcmp-form-ctrl" name="isPhone" value="isPhone" checked={ this.state.isPhone } onChange={ (e) => this.inputChangeHandler(e) } onKeyDown={ (e) => this.onKeyUPDown(e) } />
                                            <span className="idcmp-radio-checkmark"></span>
                                        </label>
                                    </div>
                                    <div className="idcmp-radio-container">
                                        <label className="idcmp-radio-check">Time-based OTP authentication (<a className="support_app" id="supp_app" onClick={ () => this.onSupportedAppClick() }>Supported Apps</a>)
                                            <input type="radio" className="idcmp-form-ctrl" name="isTotp" value="isTotp" checked={ this.state.isTotp } onChange={ (e) => this.inputChangeHandler(e) } onKeyDown={ (e) => this.onKeyUPDown(e) } />
                                            <span className="idcmp-radio-checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                                <input type="submit" className="idcmp-btn idcmp-primary-btn" value="Confirm" onClick={ () => this.submit() } />
                            </div>
                            <div className={ this.state.isPhoneConfirm && this.state.isPhoneReg ? "idcmp-verfy-blk idcmp-admin-email-verify" : "idcmp-verfy-blk idcmp-admin-email-verify idcmp-hide" }>
                                { this.state.isCodeExpired ? <h2>Your verification code has expired!</h2> : <h2>Enter the verification code sent to the phone number <b>({ phoneNoMask })</b></h2> }

                                { !this.state.isCodeExpired && <input type="password" className="idcmp-frm-ctrl" maxLength="6" size="6" autoComplete="chrome-off" name="otp" value={ this.state.otp } onChange={ (e) => this.inputChangeHandler(e) } id="smsotp" onKeyDown={ (e) => this.on2faKeydown(e, 'verifyOtp') } /> }
                                { !this.state.isCodeExpired && <input type="submit" className="idcmp-btn idcmp-primary-btn" value="Verify &amp; Enable" onClick={ () => this.verifyOtp() } /> }
                                { !this.state.isCodeExpired && <input type="submit" className="idcmp-btn" value="Back" onClick={ () => this.back() } /> }
                                { !this.state.isCodeExpired && <p>If you have not received your code, <a href="#" className={ this.state.isResendClicked ? "disabled" : "" } onClick={ (e) => { this.resendOtp(); e.preventDefault(); } }>click here to resend.</a></p> }
                                { this.state.isCodeExpired && <input type="submit" className="idcmp-btn idcmp-primary-btn" value="Resend Now!" onClick={ () => this.resendOtp() }></input> }
                            </div>
                            <div className={ this.state.isEmailConfirm ? "idcmp-verfy-blk idcmp-admin-email-verify" : "idcmp-verfy-blk idcmp-admin-email-verify idcmp-hide" }>
                                { this.state.isCodeExpired ? <h2>Your verification code has expired!</h2> : <h2>Enter the verification code sent to your registered email address</h2> }

                                { !this.state.isCodeExpired && <input type="password" className="idcmp-frm-ctrl" maxLength="6" size="6" autoComplete="chrome-off" name="otp" value={ this.state.otp } onChange={ (e) => this.inputChangeHandler(e) } id="emailotp" onKeyDown={ (e) => this.on2faKeydown(e, 'verifyOtp') } /> }
                                { !this.state.isCodeExpired && <input type="submit" className="idcmp-btn idcmp-primary-btn" value="Verify &amp; Enable" onClick={ () => this.verifyOtp() } /> }
                                { !this.state.isCodeExpired && <input type="submit" className="idcmp-btn" value="Back" onClick={ () => this.back() } /> }
                                { !this.state.isCodeExpired && <p>If you have not received your code, <a href="#" className={ this.state.isResendClicked ? "disabled" : "" } onClick={ (e) => { e.preventDefault(); this.resendOtp(); } }>click here to resend.</a></p> }
                                { this.state.isCodeExpired && <input type="submit" className="idcmp-btn idcmp-primary-btn" value="Resend Now!" onClick={ () => this.resendOtp() }></input> }

                            </div>
                            <div className={ this.state.isPhoneConfirm && !this.state.isPhoneReg ? "idcmp-verfy-blk idcmp-admin-mobile-verify" : "idcmp-verfy-blk idcmp-admin-mobile-verify idcmp-hide" }>
                                <h2>Get one-time verification code via text message</h2>
                                <p>Enter a phone number and click 'Send Code'</p>
                                {/* <div className="intl-tel-input allow-dropdown separate-dial-code">
                                    <div className="flag-container">
                                        <div className="selected-flag" role="combobox" aria-owns="country-listbox" tabindex="0" title="United States: +1">
                                            <div className="iti-flag us"></div>
                                            <div className="selected-dial-code">+1</div>
                                            <div className="iti-arrow"></div>
                                        </div><ul className="country-list hide" id="country-listbox" aria-expanded="false" role="listbox" aria-activedescendant="iti-item-us">
                                            <li className="country preferred active" id="iti-item-us" role="option" data-dial-code="1" data-country-code="us" aria-selected="true">
                                                <div className="flag-box"><div className="iti-flag us"></div></div><span className="country-name">United States</span><span className="dial-code">+1</span></li><li className="country preferred" id="iti-item-gb" role="option" data-dial-code="44" data-country-code="gb"><div className="flag-box"><div className="iti-flag gb"></div></div><span className="country-name">United Kingdom</span><span className="dial-code">+44</span></li><li className="divider" role="separator" aria-disabled="true">
                                            </li></ul>
                                    </div>
                                    <input type="text" className="idcmp-frm-ctrl" id="phone" autoComplete="off" data-intl-tel-input-id="0" placeholder="201-555-0123" style={{paddingLeft: '6px'}}/>
                                </div> */}
                                {/* <PhoneInput
                                    country={'us'}
                                    value={this.state.phone}
                                    onChange={phone => this.setState({ phone })}
                                    preferredCountries= {['us','gb']} preserveOrder={ 'preferredCountries'} countryCodeEditable={false}
                                /> */}
                                <div className="field_wrap">
                                    {/* <label style={{display:'block'}}>Country Code</label> */ }
                                    <div className="custom_select_box coutry_code_wrap" >
                                        <select name="countryCode" id="countryCode" value={ this.state.countryCode } onChange={ (e) => this.inputChangeHandler(e) }>
                                            <option value="" style={ { display: "none" } } disabled={ true }>Select the country code</option>
                                            <option value="USA +1">USA +1</option>
                                            <option value="Afghanistan +93">Afghanistan +93 </option>
                                            <option value="Albania +355">Albania +355 </option>
                                            <option value="Algeria +213">Algeria +213 </option>
                                            <option value="American Samoa +684">American Samoa +684 </option>
                                            <option value="Andorra +376">Andorra +376 </option>
                                            <option value="Angola +244">Angola +244 </option>
                                            <option value="Anguilla +1-264">Anguilla +1-264 </option>
                                            <option value="Antarctica +672">Antarctica +672 </option>
                                            <option value="Antigua and Barbuda +1-268">Antigua and Barbuda +1-268 </option>
                                            <option value="Argentina +54">Argentina +54 </option>
                                            <option value="Armenia +374">Armenia +374 </option>
                                            <option value="Aruba +297">Aruba +297 </option>
                                            <option value="Australia +61">Australia +61 </option>
                                            <option value="Austria +43">Austria +43 </option>
                                            <option value="Azerbaijan +994">Azerbaijan +994 </option>
                                            <option value="Bahamas +1-242">Bahamas +1-242 </option>
                                            <option value="Bahrain +973">Bahrain +973 </option>
                                            <option value="Bangladesh +880">Bangladesh +880 </option>
                                            <option value="Barbados +1-246">Barbados +1-246 </option>
                                            <option value="Belarus +375">Belarus +375 </option>
                                            <option value="Belgium +32">Belgium +32 </option>
                                            <option value="Belize +501">Belize +501 </option>
                                            <option value="Benin +229">Benin +229 </option>
                                            <option value="Bermuda +1-441">Bermuda +1-441 </option>
                                            <option value="Bhutan +975">Bhutan +975 </option>
                                            <option value="Bolivia +591">Bolivia +591 </option>
                                            <option value="Bosnia-Herzegovina +387">Bosnia-Herzegovina +387 </option>
                                            <option value="Botswana +267">Botswana +267 </option>
                                            <option value="Brazil +55">Brazil + 55 </option>
                                            <option value="Brunei Darussalam +673">Brunei Darussalam +673 </option>
                                            <option value="Bulgaria +359">Bulgaria +359 </option>
                                            <option value="Burkina Faso +226">Burkina Faso +226 </option>
                                            <option value="Burundi +257">Burundi +257 </option>
                                            <option value="Cambodia +855">Cambodia +855 </option>
                                            <option value="Cameroon +237">Cameroon +237 </option>
                                            <option value="Canada +1">Canada +1 </option>
                                            <option value="Cape Verde +238">Cape Verde +238 </option>
                                            <option value="Cayman Islands +1-345">Cayman Islands +1-345 </option>
                                            <option value="Central African Republic +236">Central African Republic +236 </option>
                                            <option value="Chad +235">Chad +235 </option>
                                            <option value="Chile +56">Chile +56 </option>
                                            <option value="China +86">China +86 </option>
                                            <option value="Christmas Island +61">Christmas Island +61 </option>
                                            <option value="Cocos (Keeling) Islands +61">Cocos (Keeling) Islands +61 </option>
                                            <option value="Colombia +57">Colombia +57 </option>
                                            <option value="Comoros +269">Comoros +269 </option>
                                            <option value="Congo +242">Congo +242 </option>
                                            <option value="Congo, Dem. Republic +243">Congo, Dem. Republic +243 </option>
                                            <option value="Cook Islands +682">Cook Islands +682 </option>
                                            <option value="Costa Rica +506">Costa Rica +506 </option>
                                            <option value="Croatia +385">Croatia +385 </option>
                                            <option value="Cuba +53">Cuba +53 </option>
                                            <option value="Cyprus +357">Cyprus +357 </option>
                                            <option value="Czech Rep. +420">Czech Rep. +420 </option>
                                            <option value="Denmark +45">Denmark +45 </option>
                                            <option value="Djibouti +253">Djibouti +253 </option>
                                            <option value="Dominica +1-767">Dominica +1-767 </option>
                                            <option value="Dominican Republic +809">Dominican Republic +809 </option>
                                            <option value="Ecuador +593">Ecuador +593 </option>
                                            <option value="Egypt +20">Egypt +20 </option>
                                            <option value="El Salvador +503">El Salvador +503 </option>
                                            <option value="Equatorial Guinea +240">Equatorial Guinea +240 </option>
                                            <option value="Eritrea +291">Eritrea +291 </option>
                                            <option value="Estonia +372">Estonia +372 </option>
                                            <option value="Ethiopia +251">Ethiopia +251 </option>
                                            <option value="Falkland Islands (Malvinas) +500">Falkland Islands (Malvinas) +500 </option>
                                            <option value="Faroe Islands +298">Faroe Islands +298 </option>
                                            <option value="Fiji +679">Fiji +679 </option>
                                            <option value="Finland +358">Finland +358 </option>
                                            <option value="France +33">France +33 </option>
                                            <option value="French Guiana +594">French Guiana +594 </option>
                                            <option value="Gabon +241">Gabon +241 </option>
                                            <option value="Gambia +220">Gambia +220 </option>
                                            <option value="Georgia +995">Georgia +995 </option>
                                            <option value="Germany +49">Germany +49 </option>
                                            <option value="Ghana +233">Ghana +233 </option>
                                            <option value="Gibraltar +350">Gibraltar +350 </option>
                                            <option value="Great Britain +44">Great Britain +44 </option>
                                            <option value="Greece +30">Greece +30 </option>
                                            <option value="Greenland +299">Greenland +299 </option>
                                            <option value="Grenada +1-473">Grenada +1-473 </option>
                                            <option value="Guadeloupe (French) +590">Guadeloupe (French) +590 </option>
                                            <option value="Guam (USA) +1-671">Guam (USA) +1-671 </option>
                                            <option value="Guatemala +502">Guatemala +502 </option>
                                            <option value="Guinea +224">Guinea +224 </option>
                                            <option value="Guinea Bissau +245">Guinea Bissau +245 </option>
                                            <option value="Guyana +592">Guyana +592 </option>
                                            <option value="Haiti +509">Haiti +509 </option>
                                            <option value="Honduras +504">Honduras +504 </option>
                                            <option value="Hong Kong +852">Hong Kong +852 </option>
                                            <option value="Hungary +36">Hungary +36 </option>
                                            <option value="Iceland +354">Iceland +354 </option>
                                            <option value="India +91">India +91 </option>
                                            <option value="Indonesia +62">Indonesia +62 </option>
                                            <option value="Iran +98">Iran +98 </option>
                                            <option value="Iraq +964">Iraq +964 </option>
                                            <option value="Ireland +353">Ireland +353 </option>
                                            <option value="Israel +972">Israel +972 </option>
                                            <option value="Italy +39">Italy +39 </option>
                                            <option value="Ivory Coast +225">Ivory Coast +225 </option>
                                            <option value="Jamaica +1-876">Jamaica +1-876 </option>
                                            <option value="Japan +81">Japan +81 </option>
                                            <option value="Jordan +962">Jordan +962 </option>
                                            <option value="Kazakhstan +7">Kazakhstan +7 </option>
                                            <option value="Kenya +254">Kenya +254 </option>
                                            <option value="Kiribati +686">Kiribati +686 </option>
                                            <option value="Korea-North +850">Korea-North +850 </option>
                                            <option value="Korea-South +82">Korea-South +82 </option>
                                            <option value="Kuwait +965">Kuwait +965 </option>
                                            <option value="Kyrgyzstan +996">Kyrgyzstan +996 </option>
                                            <option value="Laos +856">Laos +856 </option>
                                            <option value="Latvia +371">Latvia +371 </option>
                                            <option value="Lebanon +961">Lebanon +961 </option>
                                            <option value="Lesotho +266">Lesotho +266 </option>
                                            <option value="Liberia +231">Liberia +231 </option>
                                            <option value="Libya +218">Libya +218 </option>
                                            <option value="Liechtenstein +423">Liechtenstein +423 </option>
                                            <option value="Lithuania +370">Lithuania +370 </option>
                                            <option value="Luxembourg +352">Luxembourg +352 </option>
                                            <option value="Macau +853">Macau +853 </option>
                                            <option value="Macedonia +389">Macedonia +389 </option>
                                            <option value="Madagascar +261">Madagascar +261 </option>
                                            <option value="Malawi +265">Malawi +265 </option>
                                            <option value="Malaysia +60">Malaysia +60 </option>
                                            <option value="Maldives +960">Maldives +960 </option>
                                            <option value="Mali +223">Mali +223 </option>
                                            <option value="Malta +356">Malta +356 </option>
                                            <option value="Marshall Islands +692">Marshall Islands +692 </option>
                                            <option value="Martinique (French) +596">Martinique (French) +596 </option>
                                            <option value="Mauritania +222">Mauritania +222 </option>
                                            <option value="Mauritius +230">Mauritius +230 </option>
                                            <option value="Mayotte +269">Mayotte +269 </option>
                                            <option value="Mexico +52">Mexico +52 </option>
                                            <option value="Micronesia +691">Micronesia +691 </option>
                                            <option value="Moldova +373">Moldova +373 </option>
                                            <option value="Monaco +377">Monaco +377 </option>
                                            <option value="Mongolia +976">Mongolia +976 </option>
                                            <option value="Montenegro +382">Montenegro +382 </option>
                                            <option value="Montserrat +1-664">Montserrat +1-664 </option>
                                            <option value="Morocco +212">Morocco +212 </option>
                                            <option value="Mozambique +258">Mozambique +258 </option>
                                            <option value="Myanmar +95">Myanmar +95 </option>
                                            <option value="Namibia +264">Namibia +264 </option>
                                            <option value="Nauru +674">Nauru +674 </option>
                                            <option value="Nepal +977">Nepal +977 </option>
                                            <option value="Netherlands +31">Netherlands +31 </option>
                                            <option value="Netherlands Antilles +599">Netherlands Antilles +599 </option>
                                            <option value="New Caledonia (French) +687">New Caledonia (French) +687 </option>
                                            <option value="New Zealand +64">New Zealand +64 </option>
                                            <option value="Nicaragua +505">Nicaragua +505 </option>
                                            <option value="Niger +227">Niger +227 </option>
                                            <option value="Nigeria +234">Nigeria +234 </option>
                                            <option value="Niue +683">Niue +683 </option>
                                            <option value="Norfolk Island +672">Norfolk Island +672 </option>
                                            <option value="Northern Mariana Islands +670">Northern Mariana Islands +670 </option>
                                            <option value="Norway +47">Norway +47 </option>
                                            <option value="Oman +968">Oman +968 </option>
                                            <option value="Pakistan +92">Pakistan +92 </option>
                                            <option value="Palau +680">Palau +680 </option>
                                            <option value="Panama +507">Panama +507 </option>
                                            <option value="Papua New Guinea +675">Papua New Guinea +675 </option>
                                            <option value="Paraguay +595">Paraguay +595 </option>
                                            <option value="Peru +51">Peru +51 </option>
                                            <option value="Philippines +63">Philippines +63 </option>
                                            <option value="Poland +48">Poland +48 </option>
                                            <option value="Polynesia (French) +689">Polynesia (French) +689 </option>
                                            <option value="Portugal +351">Portugal +351 </option>
                                            <option value="Puerto Rico +1-787">Puerto Rico +1-787 </option>
                                            <option value="Qatar +974">Qatar +974 </option>
                                            <option value="Reunion (French) +262">Reunion (French) +262 </option>
                                            <option value="Romania +40">Romania +40 </option>
                                            <option value="Russia +7">Russia +7 </option>
                                            <option value="Rwanda +250">Rwanda +250 </option>
                                            <option value="Saint Helena +290">Saint Helena +290 </option>
                                            <option value="Saint Kitts &amp; Nevis Anguilla +1-869">Saint Kitts &amp; Nevis Anguilla +1-869 </option>
                                            <option value="Saint Lucia +1-758">Saint Lucia +1-758 </option>
                                            <option value="Saint Pierre and Miquelon +508">Saint Pierre and Miquelon +508 </option>
                                            <option value="Saint Vincent &amp; Grenadines +1-784">Saint Vincent &amp; Grenadines +1-784 </option>
                                            <option value="Samoa +684">Samoa +684 </option>
                                            <option value="San Marino +378">San Marino +378 </option>
                                            <option value="Sao Tome and Principe +239">Sao Tome and Principe +239 </option>
                                            <option value="Saudi Arabia +966">Saudi Arabia +966 </option>
                                            <option value="Senegal +221">Senegal +221 </option>
                                            <option value="Serbia +381">Serbia +381 </option>
                                            <option value="Seychelles +248">Seychelles +248 </option>
                                            <option value="Sierra Leone +232">Sierra Leone +232 </option>
                                            <option value="Singapore +65">Singapore +65 </option>
                                            <option value="Slovakia +421">Slovakia +421 </option>
                                            <option value="Slovenia +386">Slovenia +386 </option>
                                            <option value="Solomon Islands +677">Solomon Islands +677 </option>
                                            <option value="Somalia +252">Somalia +252 </option>
                                            <option value="South Africa +27">South Africa +27 </option>
                                            <option value="Spain +34">Spain +34 </option>
                                            <option value="Sri Lanka +94">Sri Lanka +94 </option>
                                            <option value="Sudan +249">Sudan +249 </option>
                                            <option value="Suriname +597">Suriname +597 </option>
                                            <option value="Swaziland +268">Swaziland +268 </option>
                                            <option value="Sweden +46">Sweden +46 </option>
                                            <option value="Switzerland +41">Switzerland +41 </option>
                                            <option value="Syria +963">Syria +963 </option>
                                            <option value="Taiwan +886">Taiwan +886 </option>
                                            <option value="Tajikistan +992">Tajikistan +992 </option>
                                            <option value="Tanzania +255">Tanzania +255 </option>
                                            <option value="Thailand +66">Thailand +66 </option>
                                            <option value="Togo +228">Togo +228 </option>
                                            <option value="Tokelau +690">Tokelau +690 </option>
                                            <option value="Tonga +676">Tonga +676 </option>
                                            <option value="Trinidad and Tobago +1-868">Trinidad and Tobago +1-868 </option>
                                            <option value="Tunisia +216">Tunisia +216 </option>
                                            <option value="Turkey +90">Turkey +90 </option>
                                            <option value="Turkmenistan +993">Turkmenistan +993 </option>
                                            <option value="Turks and Caicos Islands +1-649">Turks and Caicos Islands +1-649 </option>
                                            <option value="Tuvalu +688">Tuvalu +688 </option>
                                            <option value="U.K. +44">U.K. +44 </option>
                                            <option value="Uganda +256">Uganda +256 </option>
                                            <option value="Ukraine +380">Ukraine +380 </option>
                                            <option value="United Arab Emirates +971">United Arab Emirates +971 </option>
                                            <option value="Uruguay +598">Uruguay +598 </option>
                                            <option value="Uzbekistan +998">Uzbekistan +998 </option>
                                            <option value="Vanuatu +678">Vanuatu +678 </option>
                                            <option value="Vatican +39">Vatican +39 </option>
                                            <option value="Venezuela +58">Venezuela +58 </option>
                                            <option value="Vietnam +84">Vietnam +84 </option>
                                            <option value="Virgin Islands (British) +1-28284">Virgin Islands (British) +1-28484 </option>
                                            <option value="Virgin Islands (USA) +1-34040">Virgin Islands (USA) +1-34040 </option>
                                            <option value="Wallis and Futuna Islands +681">Wallis and Futuna Islands +681 </option>
                                            <option value="Yemen +967">Yemen +967 </option>
                                            <option value="Zambia +260">Zambia +260 </option>
                                            <option value="Zimbabwe +263">Zimbabwe +263 </option>
                                        </select>
                                    </div>
                                    {/* <label>Number</label> */ }
                                    <div className="phoneinput_blk">
                                        <input type="text" maxLength="20" autoComplete="chrome-off" name="phone" value={ this.state.phone } onChange={ (e) => this.inputChangeHandler(e) } onFocus={ () => this.checkPhoneRegex() } className="idcmp-frm-ctrl" id="phone" />
                                        <div className="id-tooltip id-tooltip-topright" >
                                            <p className="id-tooltip-note">Use atleast:</p>
                                            <ul>
                                                <li id="min_sev">minimum of 7 characters </li>
                                                <li id="max_twe">maximum of 20 characters</li>
                                                <li id="no_spe">only characters 0-9 x X - + ()</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <span className="err_msg" style={ { display: this.state.countrycodeempty ? "inline-block" : "none" } }>Country code cannot be blank</span> </div>
                                <span className="err_msg" style={ { display: this.state.phoneNumberEmpty ? 'inline-block' : 'none' } } >Phone number cannot be blank</span>
                                <span className="err_msg" style={ { display: this.state.phoneregex ? 'inline-block' : 'none' } } >Phone number is invalid</span>
                                <p className="form-note"><b>Note:</b> This number will be updated in your account and used to deliver all account-related notifications.</p>
                                <div className="idcmp_flex">
                                    <input type="submit" className="idcmp-btn idcmp-primary-btn" value="Send Code" onClick={ () => this.sendPhoneCode() } />
                                    <input type="submit" className="idcmp-btn" value="Back" onClick={ () => this.back() } />
                                </div>
                            </div>
                            <div className="idcmp-verfy-blk idcmp-admin-tba-verify idcmp-hide">
                                <h2>Two-factor authentication via Time-based OTP authentication</h2>
                                <p>Enter the one-time code generated by Time-based OTP Authenticator app in your mobile device, to login to your account.</p>
                                <input type="text" className="idcmp-frm-ctrl" id="otp" name="otp" value={ this.state.otp } onChange={ (e) => this.inputChangeHandler(e) } />
                                <input type="submit" className="idcmp-btn idcmp-primary-btn" value="Submit Code" />
                                <input type="submit" className="idcmp-btn" value="Back" onClick={ () => this.back() } />
                                <p><a href="#" onClick={ (e) => e.preventDefault() }>I can't access my code.</a></p>
                            </div>
                            <div className="idcmp-verfy-blk idcmp-admin-deactivate-tba-verify idcmp-hide">
                                <h2>Deactivate Time-based OTP authentication</h2>
                                <p>If you not have access to mobile device, you can disable two-factor authentication via Time-based OTP authentication by entering your 20-digit recovery code.</p>
                                <input type="text" className="idcmp-frm-ctrl" />
                                <input type="submit" className="idcmp-btn idcmp-primary-btn" value="Submit Code" />
                                <input type="submit" className="idcmp-btn" value="Back" />
                            </div>
                        </div>
                        { this.state.isOtpSent && <p className="idcmp-code-timer idcmp-hide"></p> }
                        <p className="idcmp-2fa-alternate idcmp-hide"><a href="2fa-email.html" title="Receive verification code via email adress">Receive verification code</a> via email adress.</p>
                        { !this.state.isTotpConfirm && this.state.isOtpSent && <p className="idcmp-code-timer" id="otp_timer"></p> }
                    </div>
                </div>
                <footer>
                    <p className="idcmp-copy">© IDrive Inc.</p>
                </footer>
                { (this.state.message != '') ? <CommonMessage message={ this.state.message } msgType={ this.state.msgType } handler={ () => this.setState({ message: '', msgType: '' }) } /> : null }

                <div className="master_wrapper idcmp-totp-pop">
                    <div className="shadow_container transLayer"></div>
                    <div className="popup_wrapper">
                        <div className="first_pos_container">
                            <div className="sec_pos_container">
                                <div className="opaclayer_common">
                                    <div className="popup_container prompt-box">
                                        <section className="popup_content">
                                            <div className="account_cancel_box">
                                                <div className="idcmp-totp-pop-block">
                                                    <div className="idcmp-2fa-totp">
                                                        <div className="popup_header">
                                                            <h2 className="account_cancel">Enable Time-based OTP authentication</h2>
                                                            <span className="popup_close_btn" onClick={ () => this.onTotpCloseClick() }></span>
                                                        </div>
                                                        <div className="popup_innerCtnr">
                                                            <p>Generate one-time codes via Time-based OTP authenticator app for validating your logins to IDrive Compute for stronger security.</p>
                                                            <span>Steps to configure Time-based OTP authentication:</span>
                                                            <ol>
                                                                <li value="1">Install and launch the Time-based OTP Authenticator app on your mobile device.</li>
                                                                <li>Add a new time-based key.</li>
                                                                <li className="scanOpt" style={ { display: this.state.isQrcodeShow ? '' : 'none' } }>Scan the QR code below or <a href="#" id="idManual" title="enter key manually" onClick={ (e) => { this.setState({ isQrcodeShow: false }); e.preventDefault(); } }>enter key manually.</a></li>
                                                                <li className="keyOpt" style={ { display: !this.state.isQrcodeShow ? '' : 'none' } }>Enter the key below or <a href="#" className="scan_qr" onClick={ (e) => { this.setState({ isQrcodeShow: true }); e.preventDefault(); } }>scan the QR code.</a> </li>
                                                            </ol>
                                                            <div className="idcmp-2fa-qrcode">
                                                                <QRCode style={ { display: this.state.isQrcodeShow ? '' : 'none' } }
                                                                    id="qr-gen"
                                                                    value={ this.state.qrValue }
                                                                    size={ 120 }
                                                                    level={ "H" }
                                                                    includeMargin={ true }
                                                                />
                                                                <b style={ { display: !this.state.isQrcodeShow ? '' : 'none' } }>{ this.state.secretKey }</b>
                                                            </div>
                                                        </div>
                                                        <div className="popup_footer">
                                                            <div className="idcmp-2fa-totp-btns">
                                                                <input type="button" value="Cancel" className="idcmp-btn" onClick={ () => this.onTotpCloseClick() } />
                                                                <input type="button" value="Next" className="idcmp-btn idcmp-primary-btn" onClick={ () => this.onNextTotpClick() } />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="idcmp-2fa-copycode">
                                                        <div className="popup_header">
                                                            <h2 className="account_cancel">Enable Time-based OTP authentication</h2>
                                                            <span className="popup_close_btn" onClick={ () => this.onTotpCloseClick() }></span>
                                                        </div>
                                                        <div className="popup_innerCtnr">
                                                            <p>You will require this recovery code to deactivate two-factor authentication for your account, in case you lose access to your mobile device where the Time-based OTP Authenticator app is installed. </p>
                                                            <p>Store the following recovery code safely before activating two-factor authentication. Copy/Print/Download the code to proceed.</p>
                                                            <div className="idcmp-2fa-copylink"><b>  { this.state.recoveryCode } </b><button className="copy_btn" onClick={ (e) => this.copyCodeClick(e) }>Copy Code</button></div>
                                                            <div className="idcmp-2fa-dowprint">
                                                                <a href="#" id="download_link" download="IDriveCompute_Recovery_Code.txt" className="dwnld-btn" onClick={ (e) => { this.downloadTotpCodeFlile(this.state.recoveryCode); e.preventDefault(); } }>Download</a>
                                                                <Link to={ { pathname: "/print-recovery-login/" + this.state.userId } } target={ "_blank" }><a className="prnt-btn" onClick={ () => this.setState({ isCodeCopied: true }) }>Print</a></Link>
                                                            </div>
                                                        </div>
                                                        <div className="popup_footer">
                                                            <div className="idcmp-2fa-totp-btns">
                                                                <div className="idcmp-2fa-copycode-btns">
                                                                    <input type="button" value="Back" className="idcmp-btn" onClick={ () => this.onBackTotpClick() } />
                                                                    <input type="button" value="Continue" className={ this.state.isCodeCopied ? "idcmp-btn idcmp-primary-btn" : "idcmp-btn idcmp-primary-btn disabled" } onClick={ () => this.onContinueTotpClick() } />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="idcmp-2fa-verifycode">
                                                        <div className="popup_header">
                                                            <h2 className="account_cancel">Time-based OTP authentication</h2>
                                                            <span className="popup_close_btn" onClick={ () => this.onTotpCloseClick() }></span>
                                                        </div>
                                                        <div className="popup_innerCtnr">
                                                            <p>Enter the one-time code generated by the Time-based OTP Authenticator app in your computer, to login to your account</p>
                                                            <div className="idcmp-2fa-inputgroup">
                                                                <label className="idcmp-frm-ctrl">Enter one-time code</label>
                                                                <input type="password" name="totpCode" value={ this.state.totpCode } onChange={ (e) => this.inputChangeHandler(e) } autoComplete="chrome-off" maxLength="6" id="totpcode" onKeyDown={ (e) => this.on2faKeydown(e, 'verifyTotp') } />
                                                                <span style={ { color: '#e84242' } }>{ this.state.totpErrorMssg }</span>
                                                            </div>
                                                        </div>
                                                        <div className="popup_footer">
                                                            <div className="idcmp-2fa-verifycode-btns">
                                                                <input type="button" value="Cancel" className="idcmp-btn " onClick={ () => this.onTotpCloseClick() } />
                                                                <input type="button" value="Enable" className="idcmp-btn idcmp-primary-btn" autoComplete="chrome-off" onClick={ () => this.verifyTotp() } />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    { (this.state.message_v2 != '') ? <CommonMessage message={ this.state.message_v2 } msgType={ this.state.msgType_v2 } handler={ () => this.setState({ message_v2: '', msgType_v2: '' }) } /> : null }
                </div>
                <div className="master_wrapper totpSupport_popup">
                    <div className="shadow_container transLayer"></div>
                    <div className="popup_wrapper">
                        <div className="first_pos_container">
                            <div className="sec_pos_container">
                                <div className="opaclayer_common">
                                    <div className="popup_container prompt-box">
                                        <div className="popup_content">
                                            <div className="popup_header">
                                                <h2 className="account_cancel">TOTP Supported Apps</h2>
                                                <span className="popup_close_btn" onClick={ () => { this.onSupportedAppCloseClick(); } }></span>
                                            </div>
                                            <div className="popup_innerCtnr">
                                                <p>You can choose from any of the available apps for your mobile platform. Any two-factor authentication app that supports time-based one-time protocol or is compatible with Google Authenticator can also be used.</p>
                                                <ul className="totpSupport_list">
                                                    <li>
                                                        <a href="https://support.google.com/accounts/answer/1066447?hl=en" target="_blank">Google Authenticator</a> (Android/iPhone/BlackBerry)</li>
                                                    <li>
                                                        <a href="http://guide.duosecurity.com/third-party-accounts" target="_blank">Duo Mobile</a> (Android/iPhone)</li>
                                                    <li>
                                                        <a href="https://www.microsoft.com/en-us/store/apps/authenticator/9wzdncrfj3rj" target="_blank">Microsoft Authenticator</a> (Android/iPhone/Windows Phone 7)</li>
                                                    <li>
                                                        <a href="https://play.google.com/store/apps/details?id=com.okta.android.auth" target="_blank">Okta Verify</a> (Android/iPhone)</li>
                                                    <li>
                                                        <a href="https://authy.com/features/setup/" target="_blank">Authy</a> (Android/iPhone)</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="captcha">
                    <ReCAPTCHA
                        sitekey="6LfMaG8aAAAAADtCmgI91y-9wbCjnaDTQwwIUv6-"
                        onChange={ (e) => this.onRecaptchaChange(e) }
                        ref={ this.recaptchaRef }
                        size="invisible"
                    />
                </div>
            </body>
        );
    }
}

export default SubUsertwoFaLoginConfigure;